var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41485",
    "data-name": "Group 41485",
    transform: "translate(19096 -1942)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15744",
    "data-name": "Rectangle 15744",
    width: 16,
    height: 16,
    transform: "translate(-19096 1942)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hierachy_3_",
    "data-name": "hierachy (3)",
    d: "M3.4,2A1.336,1.336,0,0,0,2.06,3.11a4.738,4.738,0,0,0,0,1.511A1.337,1.337,0,0,0,3.4,5.733H4.567V12.5a1.867,1.867,0,0,0,1.867,1.867H7.626a5.47,5.47,0,0,0,.1.6A1.341,1.341,0,0,0,9.051,16h5.492a1.341,1.341,0,0,0,1.32-1.015,4.409,4.409,0,0,0,0-2.174A1.339,1.339,0,0,0,14.546,11.8H9.05a1.34,1.34,0,0,0-1.323,1.029,5.4,5.4,0,0,0-.1.6H6.433A.933.933,0,0,1,5.5,12.5V9.233H7.626a5.47,5.47,0,0,0,.1.6,1.341,1.341,0,0,0,1.324,1.031h5.492a1.341,1.341,0,0,0,1.32-1.015,4.409,4.409,0,0,0,0-2.174,1.339,1.339,0,0,0-1.318-1.012H9.05A1.34,1.34,0,0,0,7.726,7.7a5.4,5.4,0,0,0-.1.6H5.5V5.733H6.664A1.336,1.336,0,0,0,8,4.635,4.554,4.554,0,0,0,8,3.1,1.334,1.334,0,0,0,6.666,2Zm0,2.8a.405.405,0,0,1-.417-.32,3.807,3.807,0,0,1,0-1.228A.4.4,0,0,1,3.4,2.933H6.666a.4.4,0,0,1,.414.313,3.624,3.624,0,0,1,0,1.238.4.4,0,0,1-.415.315ZM9.05,7.6a.408.408,0,0,0-.412.3,3.654,3.654,0,0,0,0,1.734.409.409,0,0,0,.413.3h5.492a.408.408,0,0,0,.411-.295,3.481,3.481,0,0,0,0-1.746.407.407,0,0,0-.41-.293Zm0,5.133a.408.408,0,0,0-.412.3,3.654,3.654,0,0,0,0,1.734.409.409,0,0,0,.413.3h5.492a.408.408,0,0,0,.411-.295,3.481,3.481,0,0,0,0-1.746.407.407,0,0,0-.41-.293Z",
    transform: "translate(-19097 1941)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeList);
export default __webpack_public_path__ + "static/media/tree-list.177755a85415142336337f0634d64308.svg";
export { ForwardRef as ReactComponent };